// extracted by mini-css-extract-plugin
export default {"legend":"recharts-legend_legend__HTPPS","legendItem":"recharts-legend_legendItem__LILSv","verticalLegend":"recharts-legend_verticalLegend__y02Fn"};